export function removeArrayIndex(array, index) {
  array.splice(index, 1);
  return array;
}
